import * as React from 'react';
import { GatsbySeo } from 'gatsby-plugin-next-seo';

import { useTheme } from '../hooks';
import {
  Contact,
  NewsletterSignup,
  InstagramFeed,
  Map,
  Layout,
} from '../components';

export default function ContactPage() {
  useTheme('');
  return (
    <Layout>
      <GatsbySeo title="Home" />
      <Contact />
      <NewsletterSignup />
      <InstagramFeed />
      <Map />
    </Layout>
  );
}
